module.exports = __webpack_public_path__ + "img/scholar6.cc56daaf.png";